import React, { useContext, useEffect } from "react";
import { Table, Icon, Button, Popup } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { getUserStateText } from "../../../app/util/userStateEnumOptions";
import { UserStateEnum } from "../../../app/util/userStateEnum";
import { IUsers } from "../../../app/models/user";
import EditUserClientForm from "./EditUserClientForm";

const ListUsersClient = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    getUsersByClientId,
    users,
    changeUserState,
    loadData,
  } = rootStore.clienStore;
  const { openModal } = rootStore.modalStore;
  const { user } = rootStore.userStore;

  useEffect(() => {
    getUsersByClientId();
  }, [getUsersByClientId]);

  const handleChangeState = (u: IUsers, state: UserStateEnum) => {
    changeUserState({ id: u.id, state: state });
  };

  const countAdminRol = () => {
    //cuenta cuantos usuarios administradores activos(state=1) hay en la lista
    return users.filter(
      (u) => u.isAdministrator === true && u.state === UserStateEnum.Active
    ).length;
  };
  if (!loadData) return <LoadingComponent content="Cargando" />;
  return (
    <div className="TableScroll">
    <Table striped basic unstackable compact singleLine>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Nombre</Table.HeaderCell>
          <Table.HeaderCell>Usuario de acceso</Table.HeaderCell>
          <Table.HeaderCell>Teléfono</Table.HeaderCell>
          <Table.HeaderCell>Mail notificaciones</Table.HeaderCell>
          <Table.HeaderCell>Rol</Table.HeaderCell>
          <Table.HeaderCell>Estado</Table.HeaderCell>
          <Table.HeaderCell>Acciones</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {users?.length > 0 ? (
          users.map((us) => (
            <Table.Row key={us.id}>
              <Table.Cell>{`${us.name} ${us.lastName}`}</Table.Cell>
              <Table.Cell>{us.username}</Table.Cell>
              <Table.Cell>{us.phone}</Table.Cell>
              <Table.Cell>{us.email}</Table.Cell>
              <Table.Cell>{us.isAdministrator ? "Admin" : "User"}</Table.Cell>
              <Table.Cell>{getUserStateText(us.state)}</Table.Cell>
              <Table.Cell>
                {us.state === UserStateEnum.Active ? (
                  <div>
                    <Popup
                      content="Editar usuario"
                      trigger={
                        <Button
                          icon
                          onClick={() =>
                            openModal(
                              <EditUserClientForm
                                user={us}
                                count={countAdminRol()}
                              />,
                              "Editando usuario"
                            )
                          }
                        >
                          <Icon name="edit outline" color="blue" />
                        </Button>
                      }
                    />
                    {user?.id !== us.id && (
                      <Popup
                        content="Click para Inactivar usuario"
                        trigger={
                          <Button
                            icon
                            onClick={() =>
                              handleChangeState(us, UserStateEnum.Inactive)
                            }
                          >
                            <Icon name="unlock" color="green" />
                          </Button>
                        }
                      />
                    )}
                  </div>
                ) : (
                  <div>
                    <Button icon disabled>
                      <Icon name="edit outline" color="blue" />
                    </Button>

                    <Popup
                      content="Click para Activar usuario"
                      trigger={
                        <Button
                          icon
                          onClick={() =>
                            handleChangeState(us, UserStateEnum.Active)
                          }
                        >
                          <Icon name="lock" color="red" />
                        </Button>
                      }
                    />
                  </div>
                )}
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row key="usersNull">
            <Table.Cell>No existen Usuarios </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table>
    </div>
  );
};

export default observer(ListUsersClient);
